import React, { useEffect } from "react";
import { formatNumber } from "../Utils/utils";
import { useSelector, useDispatch } from "react-redux";
import {
  updateDataForPdfUC,
  updateBtnPdfUC,
} from "../Store/secureInvestmentIncome/actions";
import { decryptEstandar } from "../Utils/CryptographyUtils";

const TableUC = ({ items }) => {
  let nrDoc = items && items[0] ? decryptEstandar(items[0].typeDoc) === "2" ? "DNI :" : decryptEstandar(items[0].typeDoc) === "3" ? "PASAPORTE:" : "CARNET EXT." : "";
  let number = items && items[0] ? decryptEstandar(items[0].nroDoc) : "";

  const data = useSelector((state) => state.cotizador.valuesPdfUC);
  const dispatch = useDispatch();
  const handleOnChange = (e) => {
    data.map((item) => (item.active = false));
    const position = e.target.getAttribute("keyword");
    const newData = data;

    newData[position].active = !newData[position].active;
    const activeBtn = newData.some((x) => x.active === true);
    dispatch(updateDataForPdfUC(newData));
    dispatch(updateBtnPdfUC(activeBtn));
  };

  useEffect(() => {
    const tmpBtn = items.some((x) => x.active === true);
    dispatch(updateBtnPdfUC(tmpBtn));
  }, []);

  return (
    <div className="md-g-wapper__container__table">
      <div className="title">COTIZACIONES</div>
      <div className="numdoc">
        {nrDoc} <span>{number}</span>
      </div>
      <div className="table-container">
        <table align="center" className="tablenew">
          <thead>
            <tr>
              <th>Moneda</th>
              <th>Prima Comercial</th>
              <th>Cobertura fallecimiento</th>
              <th>Saldo esperado</th>
              <th>Plazo</th>
              <th>Descargar simulación</th>
            </tr>
          </thead>
          <tbody>
            {items.length > 0 &&
              items.map((value, key) => {
                const item = value.responseCotizacion || "";
                const currency =
                  value.responseCotizacion === undefined
                    ? ""
                    : value.responseCotizacion.plan.idpMoneda === "USD"
                    ? "$"
                    : "S/";
                const saldoNeto = item
                  ? formatNumber.new(
                      parseFloat(item.detalle_plan.saldo_neto).toFixed(2)
                    )
                  : "0";
                const primaComercial = item
                  ? formatNumber.new(
                      parseFloat(item.detalle_plan.prima_comercial).toFixed(2)
                    )
                  : "";
                const fallecimientoCobertura = item
                  ? formatNumber.new(
                      parseFloat(item.detalle_plan.cobertura_fallecimiento).toFixed(2)
                    )
                  : "";

                
                const plazoYear = item ? item.detalle_plan.plazo  <= "1" ? " año" : " años" : "";

                const plazo = item ? item.detalle_plan.plazo + plazoYear : "";

                return (
                  <tr key={key}>
                    <td className="tdgrey">{currency}</td>
                    <td>{primaComercial}</td>
                    <td>{fallecimientoCobertura}</td>
                    <td>{saldoNeto}</td>
                    <td className="tdgrey">{plazo}</td>
                    <td className="md-g-wapper__container__table__item">
                      <label>
                        <input
                          name={`checkboxUC`}
                          keyword={key}
                          className="filled-in"
                          type="radio"
                          defaultChecked={value.active}
                          onChange={(e) => handleOnChange(e)}
                        />
                        <span className="checkbox-name"></span>
                      </label>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default TableUC;
